import React, { useState, useEffect } from 'react'
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js"
import CheckoutForm from "./checkoutform";
import { Elements } from "@stripe/react-stripe-js";


const Payment = () => {
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);

    
    useEffect(() => {
      async function fetchData() {
        let result = await axios.post("getpaymentinfo/", {isStripe: true});
        setStripePromise(loadStripe(result.data.result))
      }
      fetchData()
    }, [])
    useEffect(() => {
      async function fetchData() {
        let result = await axios.post("createintent/", {isStripe: true});
        console.log('result.data.clientSecret',result.data.clientSecret);
        setClientSecret(result.data.clientSecret)
      }
      fetchData()
    }, [])

    return (
        <div>
            <div className="page-wrapper">
                <div className="content col-6 mx-auto my-4">
                    
                  {clientSecret && stripePromise && (
                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                      <CheckoutForm />
                    </Elements>
                  )}
                </div>
            </div>
        </div>
    )
}

export default Payment
